"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TS1_LOGO_URL = exports.TOOLTIP_TIMEOUT_MS = exports.isUnderMaintenance = exports.SIGNUP_URL = exports.MAXIMUM_ACCOUNT_AGE = exports.MINIMUM_ACCOUNT_AGE = exports.SNAPI_URL = exports.CLIENT_ID = exports.ORDERS_URL = exports.COGSWORTH_URL = exports.TEAMSNAP_URL = exports.APP_URL = exports.API_URL = exports.IDENTITY_URL = exports.AMPLITUDE_API_KEY = exports.AMPLITUDE_ENVIRONMENT = exports.SHOW_LOGIN_ERROR_PAGE = exports.SHOW_FAMILY_MANAGEMENT = exports.IS_PROD = exports.ENV = void 0;
const ampli_1 = require("../ampli");
const environment_1 = __importDefault(require("./environment"));
exports.ENV = environment_1.default;
exports.IS_PROD = environment_1.default.indexOf('prod') !== -1;
exports.SHOW_FAMILY_MANAGEMENT = true;
exports.SHOW_LOGIN_ERROR_PAGE = false;
exports.AMPLITUDE_ENVIRONMENT = exports.IS_PROD ? 'tsprod' : 'tsdev';
exports.AMPLITUDE_API_KEY = ampli_1.ApiKey[exports.AMPLITUDE_ENVIRONMENT];
exports.IDENTITY_URL = {
    local: 'http://localhost:5405',
    staging: 'https://staging.identity.teamsnap.com',
    prod: 'https://identity.teamsnap.com',
}[environment_1.default];
exports.API_URL = {
    local: 'http://localhost:4010',
    staging: 'https://staging-accounts-api-prime.teamsnap.com',
    prod: 'https://accounts-api.teamsnap.com',
}[environment_1.default];
exports.APP_URL = {
    local: 'http://localhost:9004',
    staging: 'https://staging-prime.accounts.teamsnap.com',
    prod: 'https://accounts.teamsnap.com',
}[environment_1.default];
exports.TEAMSNAP_URL = {
    local: 'http://localhost:3001',
    staging: 'https://staging-classic.teamsnap.com',
    prod: 'https://go.teamsnap.com',
}[environment_1.default];
exports.COGSWORTH_URL = {
    local: 'http://localhost:3004/',
    staging: 'https://staging-cogsworth.teamsnap.com/',
    prod: 'https://auth.teamsnap.com/',
}[environment_1.default];
exports.ORDERS_URL = {
    local: 'http://localhost:3006',
    test: 'http://localhost:3006',
    staging: 'https://staging.order.teamsnap.com',
    prod: 'https://order.teamsnap.com',
}[environment_1.default];
exports.CLIENT_ID = {
    local: 'accounts_frontend_uid',
    staging: 'accounts_frontend_uid',
    prod: 'f03255abc2460e1566d0e00cfd9dcce96f3f1754e57b5f35612dd26264ca9eaa8bf6ba18d9daef16df3fba105ef87518ead46f092a5052b2a10bbc477eff6bc7',
}[environment_1.default];
exports.SNAPI_URL = {
    local: 'http://localhost:3000/',
    staging: 'https://staging-api.teamsnap.com/',
    prod: 'https://apiv3.teamsnap.com/',
}[environment_1.default];
exports.MINIMUM_ACCOUNT_AGE = 13;
exports.MAXIMUM_ACCOUNT_AGE = 130;
exports.SIGNUP_URL = exports.APP_URL + '/signup';
// toggle to true to turn on maintenance page
exports.isUnderMaintenance = false;
// UI constants
// Use a very short timeout for Cypress tests to speed up test execution
exports.TOOLTIP_TIMEOUT_MS = typeof window !== 'undefined' && window.Cypress ? 500 : 5000; // Timeout for tooltips in milliseconds
exports.TS1_LOGO_URL = 'https://ts-public-assets.teamsnap.com/icons/app/v1/jjBCSIg_jsnf2OH3Jy6Fb.svg';
